import { useQuery } from "@tanstack/react-query";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Globe, BadgeCheck } from "lucide-react";
import api from "@/lib/api";
import ArticleCard from "@/components/ArticleCard";

export default function AuthorDetail() {
  const { slug } = useParams();
  const { data: a, isLoading, isError } = useQuery({
    queryKey: ["author", slug],
    queryFn: () => api.get(`/authors/${slug}`).then((r) => r.data),
    retry: false,
  });

  if (isLoading) return <p className="py-24 text-center text-brand-muted">Loading…</p>;
  if (isError || !a)
    return (
      <div className="py-24 text-center">
        <p className="text-brand-muted">Author not found.</p>
        <Link to="/articles" className="mt-4 inline-block text-brand underline">Back to articles</Link>
      </div>
    );

  return (
    <div className="mx-auto max-w-5xl px-5 sm:px-8 pt-10">
      <Link to="/articles" className="inline-flex items-center gap-1.5 text-sm text-brand-muted hover:text-brand">
        <ArrowLeft className="h-4 w-4" /> Articles
      </Link>

      <div className="mt-8 flex flex-col items-start gap-6 rounded-2xl border border-brand-line bg-white p-8 sm:flex-row sm:items-center">
        <img src={a.image} alt={a.name} className="h-28 w-28 rounded-full object-cover" />
        <div>
          <div className="flex items-center gap-2">
            <h1 className="font-heading text-3xl text-brand-ink">{a.name}</h1>
            {a.verified && <BadgeCheck className="h-5 w-5 text-brand-sage" />}
          </div>
          <p className="mt-1 text-sm font-medium text-brand-clay">{a.role}</p>
          <p className="mt-3 max-w-2xl text-brand-muted leading-relaxed">{a.bio}</p>
          {a.website && (
            <a href={a.website} target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-1.5 text-sm text-brand hover:underline">
              <Globe className="h-4 w-4" /> Profile
            </a>
          )}
        </div>
      </div>

      <h2 className="mt-12 font-heading text-2xl text-brand-ink">Articles by {a.name.split(" ").slice(-1)[0]}</h2>
      <div className="mt-6 grid gap-7 sm:grid-cols-2 lg:grid-cols-3">
        {a.articles?.map((art, i) => (
          <ArticleCard key={art.slug} article={{ ...art, author: a }} index={i} />
        ))}
      </div>
    </div>
  );
}
